/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateServiceLevelRequest
 */
export interface UpdateServiceLevelRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceLevelRequest
     */
    countryCode: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceLevelRequest
     */
    regularPricingPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceLevelRequest
     */
    strategyPricingPlanId: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateServiceLevelRequest
     */
    expensePricingPlanId: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateServiceLevelRequest
     */
    profileViewsLimit?: number;
}

/**
 * Check if a given object implements the UpdateServiceLevelRequest interface.
 */
export function instanceOfUpdateServiceLevelRequest(value: object): value is UpdateServiceLevelRequest {
    if (!('countryCode' in value) || value['countryCode'] === undefined) return false;
    if (!('regularPricingPlanId' in value) || value['regularPricingPlanId'] === undefined) return false;
    if (!('strategyPricingPlanId' in value) || value['strategyPricingPlanId'] === undefined) return false;
    if (!('expensePricingPlanId' in value) || value['expensePricingPlanId'] === undefined) return false;
    return true;
}

export function UpdateServiceLevelRequestFromJSON(json: any): UpdateServiceLevelRequest {
    return UpdateServiceLevelRequestFromJSONTyped(json, false);
}

export function UpdateServiceLevelRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateServiceLevelRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'countryCode': json['countryCode'],
        'regularPricingPlanId': json['regularPricingPlanId'],
        'strategyPricingPlanId': json['strategyPricingPlanId'],
        'expensePricingPlanId': json['expensePricingPlanId'],
        'profileViewsLimit': json['profileViewsLimit'] == null ? undefined : json['profileViewsLimit'],
    };
}

export function UpdateServiceLevelRequestToJSON(value?: UpdateServiceLevelRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'countryCode': value['countryCode'],
        'regularPricingPlanId': value['regularPricingPlanId'],
        'strategyPricingPlanId': value['strategyPricingPlanId'],
        'expensePricingPlanId': value['expensePricingPlanId'],
        'profileViewsLimit': value['profileViewsLimit'],
    };
}

